export enum TrackerStatus {
    Published = 'Published',
    Draft = 'Draft',
    SoftDelete = 'SoftDelete',
    HardDelete = 'HardDelete'
}
